<label
  *ngIf="!isCompoundFieldMember && showLabel"
  [attr.for]="id"
  soho-label
    [required]="required$ | async"
  lm-label
    [layoutField] = "field"
    [layoutInfo]="layoutInfo"
    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
    [personalize]="personalize && !field?.label?.textStyle.color"
  lm-text-style
    [textStyle]="field?.label?.textStyle"
  (blur)="onBlur($event)"
>{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
</label>

<ng-container [ngSwitch]="formType">
  <ng-container *ngSwitchCase="formDisplayType.SEARCH_FORM">
    <ng-container *ngIf="isCompoundFieldMember; else NormalFieldOnSearchForm">
      <!-- On a search form and in the preview mode (occurs in the lm-compact-dialog modal) -->
      <ng-container *ngIf="lmParagraphLayoutInfo.previewMode; then CompoundPlaceHolderDisplayPreviewMode; else NormalMode"></ng-container>
      <!-- On a search form, just a compound field member NOT in the preview -->
      <ng-template #NormalMode>
        <div>
          <ng-container [ngSwitch]="displayType">
            <input *ngSwitchCase="layoutDisplayType.PLAIN"
              [attr.id]="id"
              [attr.bindId]="bindId"
              [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
              [attr.maxlength]="maxLength"
              [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
              (ngModelChange)="onNgModelChange($event)"
              #Input
                [ngClass]="fieldClassesString"
                [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
              soho-lookup
                icon="{{iconDisplay}}"
                [click]="onLookupClick"
                [field]="onLookupField"
                [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async) || isCompoundFieldMember)"
              lm-displayupper
                [isUpperCase]="isUpperCase"
              lm-field-style
                [specField]="specField"
                [recalculateStyles]="triggerValueChange | async"
              soho-busyindicator
                blockUI="true"
                displayDelay="0"
              soho-alert
              (focus)="onFocus($event)"
              (blur)="onBlur($event)"
            />
            <input *ngSwitchCase="layoutDisplayType.MASK"
              #Input
              [ngClass]="fieldClassesString"
              [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
              [attr.id]="id"
              [attr.bindId]="bindId"
              [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
              [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
              (ngModelChange)="onNgModelChange($event)"
              soho-lookup
                icon="{{iconDisplay}}"
                [click]="onLookupClick"
                [field]="onLookupField"
                [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async) || isCompoundFieldMember)"
              lm-field-style
                [specField]="specField"
                [recalculateStyles]="triggerValueChange | async"
              soho-mask
                [options]="maskOptions"
              soho-busyindicator
                blockUI="true"
                displayDelay="0"
               soho-alert
              (focus)="onFocus($event)"
              (blur)="onBlur($event)"
            />
          </ng-container>
          <!-- Handle displaying the label or value as text when not showField (the field isn't focused)-->
          <ng-container *ngIf="true; then CompoundPlaceHolderDisplayNormalMode"></ng-container>
        </div>
      </ng-template>
    </ng-container>
    <ng-template #NormalFieldOnSearchForm>
        <ng-container [ngSwitch]="displayType">
          <input *ngSwitchCase="layoutDisplayType.PLAIN"
            #Input
            [ngClass]="fieldClassesString"
            [attr.id]="id"
            [attr.bindId]="bindId"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
            (ngModelChange)="onNgModelChange($event)"
            [readonly]="(readOnly$ | async) ? true : null"
            soho-lookup
              icon="{{iconDisplay}}"
              [click]="onLookupClick"
              [field]="onLookupField"
              [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async))"
            lm-displayupper
              [isUpperCase]="isUpperCase"
            lm-field-style
              [specField]="specField"
              [recalculateStyles]="triggerValueChange | async"
            soho-alert
            soho-busyindicator
              blockUI="true"
              displayDelay="0"
            soho-tooltip content="{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions}}"
            soho-field-filter
              [fieldDropdownDataSet]="(this.model.isCubeSearchForm) ? cubeFilterSettings : alphaFilterSettings"
              [selectedFilterType]="triggerValueChange | async | toFieldOperator : modelField :'contains'"
              (filtered)="onFiltered($event)"
              (blur)="onBlur($event)"
          />
            <ng-container *ngSwitchCase="layoutDisplayType.MASK">
                <ng-container *ngIf="transformOptions.allowMultiSelections; else single">
                    <input
                           #Input
                           [ngClass]="fieldClassesString"
                           [attr.id]="id"
                           [attr.bindId]="bindId"
                           [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
                           (ngModelChange)="onNgModelChange($event)"
                           soho-lookup
                           icon="{{iconDisplay}}"
                           [click]="onLookupClick"
                           [field]="onLookupField"
                           [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async))"
                           lm-field-style
                           [specField]="specField"
                           [recalculateStyles]="triggerValueChange | async"
                           soho-alert
                           soho-mask
                           [options]="searchFieldMaskOptions"
                           soho-busyindicator
                           blockUI="true"
                           displayDelay="0"
                           soho-tooltip content="{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions}}"
                           soho-field-filter
                           [fieldDropdownDataSet]="numericFilterSettings"
                           [selectedFilterType]="triggerValueChange | async | toFieldOperator : modelField"
                           (filtered)="onFiltered($event)"
                           (blur)="onBlur($event)"
                    />
                </ng-container>
                <ng-template #single>
                    <input *ngSwitchCase="layoutDisplayType.MASK"
                           #Input
                           [ngClass]="fieldClassesString"
                           [attr.id]="id"
                           [attr.bindId]="bindId"
                           [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
                           (ngModelChange)="onNgModelChange($event)"
                           [readonly]="(readOnly$ | async) ? true : null"
                           soho-lookup
                           icon="{{iconDisplay}}"
                           [click]="onLookupClick"
                           [field]="onLookupField"
                           [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async))"
                           lm-field-style
                           [specField]="specField"
                           [recalculateStyles]="triggerValueChange | async"
                           soho-alert
                           soho-mask
                           [options]="maskOptions"
                           soho-busyindicator
                           blockUI="true"
                           displayDelay="0"
                           soho-tooltip content="{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions}}"
                           soho-field-filter
                           [fieldDropdownDataSet]="(this.model.isCubeSearchForm) ? cubeFilterSettings : numericFilterSettings"
                           [selectedFilterType]="triggerValueChange | async | toFieldOperator : modelField"
                           (filtered)="onFiltered($event)"
                           (blur)="onBlur($event)"
                    />
                </ng-template>
            </ng-container>
            <ng-container *ngIf="showBarCodeScanOptions">
              <lm-scan-options
                [isMemberField]="isCompoundFieldMember"
                [dataEntryMode]="dataEntryMode"
                [hasContextMenu]="true"
                [displayScanOptions]="true"
                [ajaxCallbackFunction]="onBeforeScanContextMenuOpen"
                [contextMenuEventFunction]="contextMenuClicked"
                [buttonId]="scanOptionsId"
                [isInAccessibilityMode]="isInAccessibilityMode"
              ></lm-scan-options>
            </ng-container>
        </ng-container>
    </ng-template>
  </ng-container>
  <!-- Not on a search form -->
  <ng-container *ngSwitchDefault>
    <div
      [ngClass]="{'disabled-member-field': disabledMemberField, 'lm-is-display-as-tag': displayAsTag, 'lm-is-display-as-text': displayAsText }"
      lm-field-options
        [isMemberField]="isCompoundFieldMember"
        [dataEntryMode]="dataEntryMode"
        [hasContextMenu]="insertContextMenu"
        [ajaxCallbackFunction]="onBeforeContextMenuOpen"
        [contextMenuEventFunction]="contextMenuClicked"
        [buttonId]="fieldOptionsId"
        [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
        [isInAccessibilityMode]="isInAccessibilityMode"
        [displayFieldOptions]="displayFieldOptions"
        [fieldAutomationId]="fieldAutomationId"
      lm-layout-util
        [hideWhiteSpace]="!(lmColumnLayoutInfo && lmColumnLayoutInfo.nbrColumns > 1)"
      soho-tooltip
        [popover]="true"
        [title]="popoverTitle"
        [placement]="'right'"
        [trigger]="'click'"
      (focus)="onFocus($event)"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)"
      (contextmenu)="onContextMenu($event)">
      <ng-container [ngSwitch]="displayType">
        <input *ngSwitchCase="layoutDisplayType.PLAIN"
          #Input
          [ngClass]="fieldClassesString"
          [attr.id]="id"
          [id]="id"
          [attr.bindId]="bindId"
          [attr.maxlength]="maxLength"
          [attr.aria-label]="(isCompoundFieldMember) ? (triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields) : null"
          [readonly]="(readOnly$ | async) ? true : null"
          [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
          [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
          (ngModelChange)="onNgModelChange($event)"
          soho-lookup
            icon="{{iconDisplay}}"
            [click]="onLookupClick"
            [field]="onLookupField"
            [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async) || isCompoundFieldMember)"
          lm-displayupper
            [isUpperCase]="isUpperCase"
          lm-field-style
            [specField]="specField"
            [recalculateStyles]="triggerValueChange | async"
          soho-alert
          soho-trackdirty
            [searchForm]="onSearchForm"
            (dirty)="onDirty($event)"
            (pristine)="onPristine($event)"
            (afterResetDirty)="onAfterResetDirty($event)"
          soho-input-validate
            (error)="onError($event)"
            (valid)="onValid($event)"
          soho-busyindicator
            blockUI="true"
            displayDelay="0"
          (blur)="onBlur($event)"
          (input)="onInput($event)"
        />
        <input *ngSwitchCase="layoutDisplayType.MASK"
          #Input
          [ngClass]="fieldClassesString"
          [attr.id]="id"
          [id]="id"
          [attr.bindId]="bindId"
          [attr.aria-label]="(isCompoundFieldMember) ? (triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields) : null"
          [readonly]="(readOnly$ | async) ? true : null"
          [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
          [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
          (ngModelChange)="onNgModelChange($event)"
          soho-lookup
            icon="{{iconDisplay}}"
            [click]="onLookupClick"
            [field]="onLookupField"
            [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async) || isCompoundFieldMember)"
          lm-field-style
            [specField]="specField"
            [recalculateStyles]="triggerValueChange | async"
          soho-mask
            [options]="maskOptions"
          soho-alert
          soho-trackdirty
            [searchForm]="onSearchForm"
            (dirty)="onDirty($event)"
            (pristine)="onPristine($event)"
            (afterResetDirty)="onAfterResetDirty($event)"
          soho-input-validate
            (error)="onError($event)"
            (valid)="onValid($event)"
          soho-busyindicator
            blockUI="true"
            displayDelay="0"
          (blur)="onBlur($event)"
          (input)="onInput($event)"
        />

        <!-- display as tag -->
        <div *ngSwitchCase="layoutDisplayType.TAG"
            class="tag-container"
            soho-alert
            lm-field-style
                [fieldStyle]="layoutObject?.fieldStyle"
                [specField]="specField"
                [recalculateStyles]="triggerValueChange | async"

        >
            <span class="tag is-dismissible"
                [attr.id]="id"
                [attr.tabindex]="isInAccessibilityMode ? 0 : null"
                [class.data]="true"
                [ngClass]="{'is-active': isFieldTagFocused, 'is-focused': isFieldTagFocused, 'hide-focus': !isFieldTagFocused}"
                [ngStyle]="{'display': 'inline-block', 'color': '#FFFFFF', 'outline': 'none'}"
                soho-alert
                lm-field-style
                    [fieldStyle]="tagStyle?.style"
                    [specField]="specField"
                    [isTag]="true"
                    [recalculateStyles]="triggerValueChange | async"
                (focus)="onTagFocus()"
                (blur)="onTagBlur()"
            >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</span>
        </div>

        <!-- display as text -->
        <p *ngSwitchCase="layoutDisplayType.TEXT"
            attr.id="{{id}}"
            [attr.tabindex]="isInAccessibilityMode ? 0 : null"
            class="lm-text-data hide-white-space"
            [class.personalize-text]="personalize && !layoutObject?.fieldStyle?.color"
            [ngStyle]="{'display': 'inline-block'}"
            [class.data]="true"
            soho-alert
            lm-field-style
              [fieldStyle]="layoutObject?.fieldStyle"
              [specField]="specField"
              [recalculateStyles]="triggerValueChange | async"
        >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>

        <ng-container *ngIf="showCompactDialogButton">
          <button
            soho-button="btn-icon"
            icon="launch"
            id="CompactForm"
            class="lm-compound-field-dialog-button"
            (click)="openCompactDialog($event)"
            soho-tooltip
            [content]="launchButtonTooltip"
          >
            <span class="audible">{{launchButtonTooltip}}</span>
          </button>
        </ng-container>

        <ng-container *ngIf="showBarCodeScanOptions">
          <lm-scan-options
              [isMemberField]="isCompoundFieldMember"
              [dataEntryMode]="dataEntryMode"
              [hasContextMenu]="true"
              [displayScanOptions]="true"
              [ajaxCallbackFunction]="onBeforeScanContextMenuOpen"
              [contextMenuEventFunction]="contextMenuClicked"
              [buttonId]="scanOptionsId"
              [isInAccessibilityMode]="isInAccessibilityMode"
          ></lm-scan-options>
        </ng-container>

        <!-- Handle the compound field member display label/value not focused in compact format on a form -->
        <ng-container *ngIf="isCompoundFieldMember">
          <div *ngIf="lmParagraphLayoutInfo?.previewMode; then CompoundPlaceHolderDisplayPreviewMode; else CompoundPlaceHolderDisplayNormalMode"></div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #CompoundPlaceHolderDisplayNormalMode>
    <span *ngIf="isDirty" class="icon-dirty lm-compound-member-field-dirty"></span>
    <ng-container *ngIf="!(modelField.valueChanged | async | isBlankValue:specField); else noValue" >
        <p
            attr.id="{{id}}-text"
            class="lm-compound-text hide-white-space"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            [attr.tabindex]="(!disabledMemberField) ? tabIndexForFieldOptions : null"
            [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
            soho-tooltip
            [content]="triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields"
            soho-alert
            (focus)="onFocus($event)"
        >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>
    </ng-container>
    <ng-template #noValue>
        <p
            attr.id="{{id}}-text"
            [attr.tabindex]="(!disabledMemberField) ? tabIndexForFieldOptions : null"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            [ngClass]="{'lm-compound-text preview-placeholder': true, 'input-style is-placeholder': !(readOnly$ | async)}"
            [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
            soho-tooltip
            [content]="showLabel ? '' : triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields"
            soho-alert
            (focus)="onFocus($event)"
        >{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
    </ng-template>
</ng-template>

<ng-template #CompoundPlaceHolderDisplayPreviewMode>
    <ng-container *ngIf="!(isCompoundFieldMember && (modelField.valueChanged | async | isBlankValue:specField)); else noValue" >
        <p
            attr.id="{{id}}-text"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            class="lm-compound-text hide-white-space"
            [ngStyle]="{'display': 'inline-block'}"
            soho-alert
        >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>
    </ng-container>
    <ng-template #noValue>
        <p
            attr.id="{{id}}-text"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            [ngClass]="{'lm-compound-text preview-placeholder': true, 'input-style is-placeholder': !(readOnly$ | async)}"
            [ngStyle]="{'display': 'inline-block'}"
            soho-alert
        >{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
    </ng-template>
</ng-template>

<div #dialogPlaceholder id="lmLookupDialogPlaceholder" class="lmDialogPlaceholder"></div>
<!-- <div #dialogPlaceholder id="lmLookupDialogPlaceholder" [ngClass]="{'modal': isModal}"></div> -->

<ng-template #mouseOverTextTemplate>
  <ng-container *ngIf="layoutObject.mouseOverText">
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  </ng-container>
</ng-template>
